import { Link } from "react-router-dom";
import AppShell from "@/components/AppShell";
import HistoryTable from "@/components/wallet/HistoryTable";

export default function ProfileHistory() {
  return (
    <AppShell>
      <div className="space-y-6">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <h1 className="text-2xl font-semibold">Transaction history</h1>
            <p className="mt-1 text-sm text-muted-foreground">
              Deposits, withdrawals, transfers and settlements on your account.
            </p>
          </div>
          <div className="flex gap-2">
            <Link
              to="/p2p/orders"
              className="rounded-lg border border-border bg-surface-2 px-3 py-1.5 text-xs font-medium transition hover:border-primary"
              data-testid="history-p2p-orders"
            >
              P2P orders
            </Link>
            <Link
              to="/otc"
              className="rounded-lg border border-border bg-surface-2 px-3 py-1.5 text-xs font-medium transition hover:border-primary"
              data-testid="history-otc"
            >
              OTC trades
            </Link>
          </div>
        </div>
        <HistoryTable />
      </div>
    </AppShell>
  );
}
